import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { toast } from 'sonner';
import { theme } from '../../styles/theme';
import Input from '../common/Input';
import Button from '../common/Button';
import { login } from '../../api/auth';
import { useAuthStore } from '../../store/authStore';

const LoginForm = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState({});
  
  const navigate = useNavigate();
  const { setAuthStatus } = useAuthStore();
  
  const validate = () => {
    const newErrors = {};
    
    if (!email.trim()) {
      newErrors.email = 'E-Mail-Adresse wird benötigt';
    }
    
    if (!password) {
      newErrors.password = 'Passwort wird benötigt';
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validate()) {
      return;
    }
    
    setIsLoading(true);
    
    try {
      const userData = await login({ email, password });
      setAuthStatus(true, userData);
      toast.success('Erfolgreich angemeldet');
      navigate('/app');
    } catch (error) {
      console.error('Login error:', error);
      // Error handling is done in the API interceptor
    } finally {
      setIsLoading(false);
    }
  };
  
  return (
    <Form onSubmit={handleSubmit}>
      <FormTitle>Anmelden</FormTitle>
      
      <Input
        id="email"
        label="E-Mail"
        type="email"
        fullWidth
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        error={errors.email}
      />
      
      <Input
        id="password"
        label="Passwort"
        type="password"
        fullWidth
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        error={errors.password}
      />
      
      <ButtonContainer>
        <Button
          type="submit"
          fullWidth
          isLoading={isLoading}
        >
          Anmelden
        </Button>
      </ButtonContainer>
    </Form>
  );
};

const Form = styled.form`
  max-width: 400px;
  width: 100%;
  background-color: ${theme.colors.surface};
  border-radius: ${theme.borderRadius.lg};
  padding: 2rem;
  box-shadow: ${theme.boxShadow.lg};
`;

const FormTitle = styled.h2`
  font-size: 1.5rem;
  margin-bottom: 1.5rem;
  text-align: center;
  color: ${theme.colors.heading};
`;

const ButtonContainer = styled.div`
  margin-top: 1.5rem;
`;

export default LoginForm;
